// items/CategoryItem.jsx
import React from "react";
import TertiaryCustomButton from "../../../../../commons/tertiary-custom-button/tertiary-custom-button"
export default function ResourceTypeItem({ item, onNext }) {
  const children = (item.content?.resource_types ?? []).map((c) => ({
    text: c.text,
    href: c.href,
  }));

  return (
    <li className="category-item">
      <TertiaryCustomButton
        classes="customize-tertiary-cls"
        title={item.title}
        onClick={() => {
          console.log('children', item)
          onNext(children,'Resources');
          // onDivisionClick(divisions);
        }}
      />
    </li>
  );
}
